<template>
  <div class="invoiceManagePage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-field label="申请金额（元）：" readonly v-model="baseData.amount" class="ggInput moreText" />
      <div class="ljdz">
        <van-field
          v-model="baseData.amountTotal"
          readonly
          label="累计办理金额（元）："
          class="ggInput moreText"
          :is-link="baseData.amountTotal>0"
          @click="jumpUrl"
        />
      </div>
      <van-field
        v-model="baseData.amountRemain"
        readonly
        label="未办理金额（元）："
        class="ggInput moreText"
      />
      <van-field
        v-if="editType"
        v-model="baseData.momentMoney"
        :required="editType"
        :readonly="!editType"
        label="本次办理金额（元）："
        class="ggInput moreText"
        :placeholder="editType?'请输入...  ':''"
      />
    </van-cell-group>
    <p class="fgx"></p>
    <div>
      <div class="itemTitle">申请详细信息</div>
      <div class="reimburseList">
        <!-- 借款申请表单 -->
        <loan-apply v-if="type == 'jk'" :id="commonId"></loan-apply>
        <!-- 报销表单 -->
        <claims-apply v-if="type == 'bx'" :id="commonId"></claims-apply>
        <!-- 保证金申请表单 -->
        <margin-apply v-if="type == 'bzj'" :id="commonId"></margin-apply>
        <!-- 资金申请表单 -->
        <capital-apply v-if="type == 'zj'" :id="commonId"></capital-apply>
        <!-- 付款申请表单 -->
        <payment-apply v-if="type == 'fk'" :id="commonId"></payment-apply>
      </div>
    </div>
    <!-- 操作按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode=='add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
      >提交</van-button>
    </div>
    <!-- 弹出框 -->
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
// import newApi from "lodash";
const projectView = () => import("@/components/businessTripMould/projectView");
// 借款
import loanApply from "@/views/financeModule/loanApplication/loanApplication-detail";
// 保证金申请表单
import marginApply from "@/views/financeModule/marginApplication/marginApplication-detail";
// 报销表单
import claimsApply from "@/views/financeModule/reimbursement/reimbursement-detail";
// 资金申请表单
import capitalApply from "@/views/financeModule/capitalManage/capitalManage-detail";
// 付款申请表单
import paymentApply from "@/views/financeModule/payment/payment-detail";
import { dateFormat } from "@/utils/common";
import { getDeviceType, closePage } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "financialManage",
  data() {
    return {
      userInfo: {
        realName: "", //借款人
        realCode: ""
      },
      type: "",
      commonId: "", //用户申请Id
      mode: "",
      orgId:"",
      editType: false,
      baseData: {
        //合同data信息
        amount: "", //申请金额
        amountTotal: "", //累计办理金额
        amountRemain: "", //未办理金额
        momentMoney: "" //本次办理金额
      },
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType() //手机类型
    };
  },
  mounted() {
    window.editPage = this.editPage; //编辑页面
    this.mode = this.$route.query.commonType;
    this.commonId = this.$route.query.commonId;
    this.type = this.$route.query.type;
    this.orgId = this.$route.query.orgId;
    this.$nextTick(() => {
      this.viewAmount();
      if (this.mode != "add") {
      } else {
        this.editType = true;
      }
      this.setShowLoad(false);
    });
  },
  components: {
    projectView,
    loanApply,
    marginApply,
    claimsApply,
    capitalApply,
    paymentApply
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    viewAmount() {
      //查看未办理、累计办理金额-陈国贵
      this.$api.finance.transact
        .viewAmount({
          accountType: this.type,
          relationId: this.commonId
        })
        .then(res => {
          if (res.code) {
            this.baseData.amount = res.data.amount;
            this.baseData.amountRemain = res.data.amountRemain;
            this.baseData.amountTotal = res.data.amountTotal;
          } else {
            this.$Message.error(res.msg);
          }
        });
    },
    checkInput() {
      if (this.baseData.momentMoney == "") {
        this.$toast("带星号为必填项，不能为空");
      } else {
        this.saveFpDetail();
      }
    },
    saveFpDetail() {
      if (parseFloat(this.baseData.momentMoney) > parseFloat(this.baseData.amountRemain)) {
        this.$toast("本次办理金额大于未办理金额，不可进行办理");
        return false;
      }
      let _this = this;
      _this.btnLoading = true;
      let params = {
        accountType: this.type,
        amount: this.baseData.momentMoney,
        relationId: this.commonId
      };
      this.$api.finance.transact
        .deal(params)
        .then(res => {
          if (res.code == "1") {
            closePage("办理成功");
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch(err => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    jumpUrl() {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      if (this.baseData.amountTotal == "0" || this.baseData.amountTotal == "") {
        return;
      } else {
        Url =
          Url +
          "/OA-pageH5/#/delHkList?token=" +
          token +
          "&commonId=" +
          this.commonId +
          "&commonType=" +
          this.type +
          "&orgId=" +
          this.orgId+
          "&pageType=2";
        if (this.clientType == "android") {
          window.android.getInfo(112, Url);
        } else {
          //IOS
          console.log(Url);
          window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
        }
      }
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.invoiceManagePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone {
    .moreText {
      .van-cell__title {
        width: 180px;
      }
    }
  }
   .fgx{
     width: 100%;
     height: 10px;
     background-color: #f6f6f6;
   }
  .itemTitle {
    position: relative;
    padding: 0 16px 0 25px;
    font-size: 15px;
    height: 45px;
    line-height: 45px;
    position: relative;
    color: #2581d6;
    font-weight: 700;
    background-color: #fff;
    border-bottom: 1px solid #e0e0e0;
    &::before {
      content: "";
      position: absolute;
      width: 5px;
      height: 21px;
      background: #2581d6;
      top: 12px;
      left: 16px;
    }
  }

  .baseNone.dwBox {
    .van-cell__title {
      width: 180px;
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
}
</style>
